export default {
    getStoreType(state){
        return state.storeType
    },

     getComponentType(state){
         return state.componentType
     },

     getProductId(state){
        return state.productId
     },

     getStoreOrderType(state){
        return state.storeOrderType
     },

     getOrderId(state){
        return state.orderId
     },

     getOrderComponet(state){
        return state.orderComponet
     },

     
}


// WEBPACK FOOTER //
// ./src/vuex/store/getter.js